import { useMemo } from "react";
import { ProfessionFilterModalInnerProps } from "../utils";
import { DoctorFilter } from "./components/doctor-filter";
import { SSKFilter } from "./components/ssk-filter";
import { TeacherFilter } from "./components/teacher-filter";
import { RadioGrapherFilter } from "./components/radiographer-filter";
import { SocionomFilter } from "./components/socionom-filter";
import { ExpOnlyFilter } from "./components/exp-only-filter";
import { PsykologFilter } from "./components/psykolog-filter";
import { Professions } from "@bonliva-crm/shared";

export const ProfessionExtraSelectors = (props: ProfessionFilterModalInnerProps) => {
  const selectedProfession = useMemo(() => {
    return props?.value?.professions?.[0];
  }, [props?.value]);

  switch (selectedProfession) {
    case Professions.SE_ARBETSTERAPEUT:
    case Professions.SE_FYSIOTERAPEUT:
    case Professions.SE_SSK:
    case Professions.NO_SYKEPLEIE:
    case Professions.DK_SYGEPLEJERSKER:
    case Professions.FI_SAIRAANHOITAJA:
      return <SSKFilter {...props} />;

    case Professions.SE_LAKARE:
    case Professions.NO_LEGE:
    case Professions.DK_LAEGER:
    case Professions.FI_LAAKARI:
      return <DoctorFilter {...props} />;

    case Professions.SE_LARARE:
      return <TeacherFilter {...props} />;

    case Professions.SE_RONTGENSJUKSKOTERSKA:
    case Professions.DK_RADIOGRAFER:
    case Professions.DK_SOCIAL_OG_SUNDHEDSASSISTENT:
      return <RadioGrapherFilter {...props} />;

    case Professions.SE_SOCIONOM:
      return <SocionomFilter {...props} />;

    case Professions.SE_PSYKOLOG:
      return <PsykologFilter {...props} />;

    case Professions.DK_JORDEMODER:
    case Professions.SE_AUDIONOM:
    case Professions.SE_BARNMORSKA:
    case Professions.SE_BIOMEDICINSK_ANALYTIKER:
    case Professions.SE_DIETIST:
    case Professions.SE_FARMACEUTER:
    case Professions.SE_HALSO_OCH_SJUKVARDKURATOR:
    case Professions.SE_INTERNREKRYTERING:
    case Professions.SE_MEDICINSKA_SEKRETERARE:
    case Professions.SE_PSYKOTERAPEUT:
    case Professions.SE_USK:
    case Professions.DK_PLEJER:
    case Professions.DK_PSYKIATRIMEDARBEJDER:
    case Professions.DK_SOCIALPAEDAGOG:
    case Professions.DK_SOCIAL_OG_SUNDHEDSHJAELPER:
    case Professions.DK_HJAELPEPLEJER:
    case Professions.DK_OMSORGSMEDARBEJDER:
    case Professions.DK_PAEDAGOGMEDHJAELPER:
      return <ExpOnlyFilter {...props} />;
    case "None":
      return null;
    default:
      return null;
  }
};
